import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex flex-col justify-center gap-4" }
const _hoisted_2 = { class: "flex flex-col place-items-center overflow-hidden" }
const _hoisted_3 = ["src"]

import BaseCard from '@/features/global/BaseCard.vue';
import WebsiteComputer from '@/assets/Projects/WebsitePhotos/WebsiteComputer.png';
import { useImageViewer } from '@/features/composables/useImageViewer';


export default /*@__PURE__*/_defineComponent({
  __name: 'WebsiteProject',
  setup(__props) {

const { openImageMenu } = useImageViewer();

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(BaseCard, {
    title: 'clairgreen.com',
    highlightLastWord: false
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _cache[1] || (_cache[1] = _createElementVNode("div", { class: "w-full grid lg:grid-cols-2 lg:gap-20" }, [
          _createElementVNode("h5", { class: "lg:justify-self-end lg:pr-6 font-medium" }, "Solo Engineer"),
          _createElementVNode("h5", { class: "lg:justify-self-start lg:pl-6 font-medium" }, "October 2024 - Present")
        ], -1)),
        _cache[2] || (_cache[2] = _createElementVNode("p", { class: "text-center items-center px-4 gap-2" }, [
          _createElementVNode("span", { class: "block" }, " This very website! Fully reactive and animated with 8 main pages "),
          _createElementVNode("span", { class: "block" }, " Developed in Vue.js, TypeScript, and CSS "),
          _createElementVNode("span", { class: "block" }, " Built from the ground up in my own design scheme "),
          _createElementVNode("span", { class: "block" }, " Created entirely by me! No AI whatsoever ")
        ], -1)),
        _createElementVNode("span", _hoisted_2, [
          _createElementVNode("img", {
            class: "w-[50%] h-auto rounded-lg cursor-pointer",
            src: _unref(WebsiteComputer),
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_unref(openImageMenu)(_unref(WebsiteComputer), 'clairgreen.com Screenshot', $event.currentTarget)))
          }, null, 8, _hoisted_3)
        ])
      ])
    ]),
    _: 1
  }))
}
}

})